import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useFormState } from 'react-hook-form';

import { ContentExpander } from 'common/components/ContentExpander';
import { IOfferEventType } from 'graphql/types';

interface IProps {
    children?: React.ReactNode;
    offerEventType: IOfferEventType;
}

export const MoreSettingsExpander = ({ children, offerEventType }: IProps) => {
    const [translate] = useTranslation();
    const [settingsExpanded, setSettingsExpanded] = useState(false);

    useEffect(() => {
        setSettingsExpanded(false);
    }, [offerEventType]);

    const { errors } = useFormState();

    const moreSettingsValidatedFields = ['trainerApproval'];
    const moreSettingsHasError = Object.keys(errors).some((errorKey) =>
        moreSettingsValidatedFields.includes(errorKey)
    );

    return (
        <ContentExpander
            renderExpanded
            expand={moreSettingsHasError || settingsExpanded}
            title={translate('moreSettings')}
            onClick={() => setSettingsExpanded(!settingsExpanded)}
        >
            {children}
        </ContentExpander>
    );
};
